module.exports = __webpack_public_path__ + "static/media/11.f123b83c.mp3";